import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route, useHistory, withRouter } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Login from '../../organismos/login';
import { SesionActionsSaga } from '../../../../infrastructure/services/sesion';

// Containers
//import { Helmet } from 'react-helmet';



const IniciarSesion = ({ recovery }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const conexionSesion = useSelector((store) => store.tk.sesion.connection);

    const handleLogin = (usuario, clave) => {
        dispatch(SesionActionsSaga.activeSesion({ userName: usuario, password: clave }));
    };

    const heandleRecoverPaswoard = (email) => {
        dispatch(SesionActionsSaga.activeRecoverPassword(email));
    };

    const handlerChangePassword = (token, password) => {
        dispatch(SesionActionsSaga.activeChangePasswordd({ token, password }));
    };

    const token = useSelector((store) => store.tk.sesion.token);
    useEffect(() => {
        console.log("ESS", token)
        //token!==null && history.push('/dasboard');
    }, [token]);

    return (
        <Container fixed>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                <Login 
                handleLogin={handleLogin} 
                heandleRecoverPaswoard={heandleRecoverPaswoard}
                handlerChangePassword={handlerChangePassword}
                statusConexion={conexionSesion} 
                recovery={recovery} />
            </Grid>
        </Container>
    );
};

export default IniciarSesion;